import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/frontier-exposure-analysis/create/')({
  beforeLoad: ({ context, preload }) => {
    const { validatePermissions, userPermissions } = context;
    const isAllowed = !!userPermissions.hasAllowedPermission({ path: PAGE_PATHS.FREA_SETTINGS, permission: Permission.UPDATE });
    validatePermissions({ isAllowed, preload });
  },
});
